import React from 'react';
import { X } from 'lucide-react';

// Caption card shown while the guided tour walks from painting to painting.
const TourOverlay = ({ painting, index, total, stepMs, onStop }) => (
  <div className="fixed bottom-32 md:bottom-20 left-1/2 -translate-x-1/2 z-40 w-[min(92vw,520px)] bg-black/75 backdrop-blur-sm text-white rounded-lg shadow-2xl overflow-hidden fade-in">
    <div className="p-4 pr-10">
      <div className="text-xs uppercase tracking-wider text-amber-300 mb-1">
        Guided tour · {index + 1} of {total}
      </div>
      <div className="text-lg font-semibold leading-tight">{painting.title}</div>
      <div className="text-xs text-gray-300 mb-2">by {painting.artist}</div>
      <p className="text-sm text-gray-200 leading-snug">{painting.description}</p>
    </div>
    <button
      onClick={onStop}
      className="absolute top-2 right-2 h-7 w-7 rounded-full flex items-center justify-center text-gray-300 hover:text-white hover:bg-white/10"
      title="Stop tour (Esc)"
    >
      <X size={16} />
    </button>
    {/* Progress bar – restarts for every painting via the key */}
    <div className="h-1 bg-white/10">
      <div key={index} className="h-full bg-amber-400 tour-progress" style={{ animationDuration: `${stepMs}ms` }} />
    </div>
  </div>
);

export default TourOverlay;
